import EvalCreateDrawer from './src/main';

/* istanbul ignore next */
EvalCreateDrawer.install = function(Vue) {
  Vue.component(EvalCreateDrawer.name, EvalCreateDrawer);
};

export default EvalCreateDrawer;
